import { useEffect, useState } from "react";
import {
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { useModals } from "../../store/dialogs/hooks";
import { Transition } from "../../pages/app/utils/animation";

const NEW_CASE = "NEW Case";
const THIS_CASE = "THIS Case";
const OTHER_CASE = "Other Case";

export const CloneDialog = ({
  cases,
  cloneClip,
  cloneClipNewCase,
  readOnly,
  selectedId,
}) => {
  const { showCloneDialog, closeCloneDialog } = useModals();
  const [optionValue, setOptionValue] = useState(null);
  const [radioValue, setRadioValue] = useState(null);
  const [selectValue, setSelectValue] = useState(null);

  const handleClose = () => {
    [setRadioValue, setOptionValue, setSelectValue].forEach((fn) => fn(null));
    closeCloneDialog();
  };

  const handleRadioChange = (e) => {
    setRadioValue(e.target.value);
    setSelectValue(null);
  };

  const handleSelectChange = (e) => setSelectValue(e.target.value);

  const handleClone = () => {
    switch (radioValue) {
      case THIS_CASE:
        cloneClip(selectedId);
        break;
      case NEW_CASE:
        cloneClipNewCase(selectedId);
        break;
      default:
        cloneClip(selectedId, selectValue);
    }
    handleClose();
  };

  useEffect(() => {
    const isStandardCase = [THIS_CASE, NEW_CASE].includes(radioValue);
    setOptionValue(isStandardCase ? radioValue : null);
  }, [radioValue]);

  return (
    <Dialog
      onClose={() => closeCloneDialog()}
      open={showCloneDialog}
      aria-hidden={!showCloneDialog}
      fullWidth
      maxWidth="xs"
      closeAfterTransition={false}
      slots={{
        transition: Transition,
      }}
      sx={{ ".MuiPaper-root": { maxWidth: 300 } }}
    >
      <DialogTitle
        sx={{ pl: 2, textTransform: "uppercase" }}
        id="clone-to-label"
      >
        Clone To
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ display: "flex", flexDirection: "column", px: 0 }}
      >
        <FormControl component="fieldset" sx={{ px: 2 }}>
          <RadioGroup
            aria-labelledby="clone-to-label"
            name="clone-to-group"
            value={radioValue}
            onChange={handleRadioChange}
          >
            <FormControlLabel
              value={THIS_CASE}
              control={<Radio disabled={readOnly} />}
              label={THIS_CASE}
            />
            <FormControlLabel
              value={NEW_CASE}
              control={<Radio />}
              label={NEW_CASE}
            />
            <FormControlLabel
              value={OTHER_CASE}
              control={<Radio />}
              label={OTHER_CASE}
            />
          </RadioGroup>
        </FormControl>
        <Collapse in={radioValue === OTHER_CASE}>
          <FormControl fullWidth sx={{ px: 2, pt: 1 }}>
            <Select
              id="clone-to-case"
              value={selectValue || ""}
              onChange={handleSelectChange}
              inputProps={{ "aria-label": "clone to case" }}
              displayEmpty
            >
              <MenuItem value="" disabled>
                Select a case
              </MenuItem>
              {cases.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.caseName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Collapse>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button
          disabled={!optionValue && !selectValue}
          variant="contained"
          onClick={handleClone}
        >
          Clone
        </Button>
      </DialogActions>
    </Dialog>
  );
};
